export default {
    YES: {
        text: 'Ja',
        value: '1'
    },
    NO:{
        text: 'Nein',
        value: '0'
    }
};